/* @flow */
/* eslint-disable max-len */
import React from 'react';
import { OutboundLink } from 'react-ga';
import { Col } from 'reactstrap';

import classes from './Footer.scss';

const env = process.env.NODE_ENV;
const commit = process.env.REACT_APP_GIT_SHA;

export const Footer = () => (
  <Col className={classes.footer}>
    <p className="mb-0">
      {`${process.env.REACT_APP_TOOL_NAME} v${process.env.VERSION} (${env}#${commit})`}
    </p>
    <p>
      {`© ${process.env.REACT_APP_COPYRIGHT_DATE} `}
      <OutboundLink
        eventLabel="homepage"
        to={`${process.env.REACT_APP_COMPANY_URL}`}
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        {`${process.env.REACT_APP_COMPANY_NAME}`}
      </OutboundLink>
    </p>
  </Col>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js